
jQuery(document).ready(function ($) {

    $(document).scroll(function () {
        if ($(document).scrollTop() > 120) {
            $("#header").addClass("active")
        } else {
            $("#header").removeClass("active")
        }
    })






    /*

    var song = $("header").data("music")
    var audio = new Audio(song)

    // récupérer l'état précédent
    var savedState = localStorage.getItem("musicState")

    // appliquer l'état au chargement
    if (savedState === "muted") {
        audio.muted = true
        $('.toggleMusic').removeClass("played").addClass("muted")
    } else {
        var p = audio.play()

        if (p) {
            p.then(function() {
                $('.toggleMusic').removeClass("muted").addClass("played")
                localStorage.setItem("musicState", "played")
            }).catch(function() {
                $('.toggleMusic').removeClass("played").addClass("muted")
                localStorage.setItem("musicState", "muted")
            })
        }
    }

    // toggle manuel
    $('.toggleMusic').click(function() {

        if ($(this).hasClass("muted")) {
            audio.muted = false
            audio.play()

            $(this).removeClass("muted").addClass("played")
            localStorage.setItem("musicState", "played")

        } else {
            audio.pause()
            audio.muted = true

            $(this).removeClass("played").addClass("muted")
            localStorage.setItem("musicState", "muted")
        }
    })

    */



})


